import { BlogArticle } from "../../../components/pages/blog/BlogArticle";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  fetchAllBlogs,
  fetchBlog,
} from "../../../services/fetch-data/blogUtil";
import { BlogData } from "../../../hooks/react-query/useBlogList";
import { MyHead } from "../../../components/pages/MyHead";
import { Fragment } from "react";
import { NotFound } from "../../../components/pages/404/NotFound";
import {Footer} from "../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps(context: any) {
  const slug: string = context.params.slug;
  let blog = undefined;
  if (!slug.includes("css")) blog = await fetchBlog(context.params.slug, context.locale);

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
      blog: blog || null,
    },
    revalidate: 60,
  };
}

/*
Prefetch all blogs on build
 */
export async function getStaticPaths() {
  const blogs = await fetchAllBlogs();
  const paths: any[] = [];
  if (blogs) {
    Object.keys(blogs).map((slug) => {
      paths.push({ params: { slug: slug } });
    });
  }
  return {
    paths: paths,
    fallback: "blocking", //indicates the type of fallback
  };
}

function BlogEntry(params: { blog: BlogData }) {
  const { blog } = params;
  return (
      <Fragment>
        {blog && (
            <Fragment>
              <MyHead
                  title={blog.title}
                  description={blog.description}
                  image={blog.image}
                  url={`/blog/${blog.urlSlug}`}
              />
              <BlogArticle blog={blog} />
            </Fragment>
        )}
        {!blog && <NotFound />}
        <Footer  isVisible={true}/>
      </Fragment>
  );
}

export default BlogEntry;

// import { BlogArticle } from "../../../components/pages/blog/BlogArticle";
// import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// import {
//   fetchAllPostsFromWP,
//   fetchPostFromWP,
// } from "../../../services/fetch-data/blogUtil";
// import { Fragment } from "react";
// import { NotFound } from "../../../components/pages/404/NotFound";
// import { Post } from "../../../types/graphql";
// import { usePaginationStore } from "../../../components/config/store/usePaginationStore";
// import useAsyncEffect from "use-async-effect";
// import { MyBlogHead } from "../../../components/pages/blog/MyBlogHead";
// import { isPhone } from "../../../constants/env";
// import { Footer } from "../../../components/pages/homepage/footer/Footer";
//
// // @ts-ignore
// export async function getStaticProps({ locale, params }) {
//   const slug: string = params.slug;
//   const post = await fetchPostFromWP(slug);
//   console.log(post);
//
//   return {
//     props: {
//       ...(await serverSideTranslations(locale, ["common"])),
//       blog: post && post.data ? post.data.post : null,
//     },
//     revalidate: 60,
//   };
// }
//
// /*
// Prefetch all blogs on build
//  */
// export async function getStaticPaths(context: any) {
//   const locales: string[] = context.locales;
//
//   const paths: any[] = [];
//   for (const locale of locales) {
//     const blogs = await fetchAllPostsFromWP(locale);
//     if (blogs.data.posts.nodes) {
//       blogs.data.posts.nodes.map((post) => {
//         paths.push({ params: { slug: post.slug }, locale });
//       });
//     }
//   }
//
//   return {
//     paths: paths.flat(),
//     fallback: "blocking", //indicates the type of fallback
//   };
// }
//
// function BlogEntry(params: { blog: Post }) {
//   const { blog } = params;
//
//   const { setAfter, setHasNextPage, after } = usePaginationStore(
//     (state) => state
//   );
//
//   //remove anchor blog if used for loading more posts
//   useAsyncEffect(async () => {
//     setHasNextPage(false);
//     setAfter(undefined);
//   }, []);
//
//   return (
//     <Fragment>
//       {blog && (
//         <Fragment>
//           <MyBlogHead post={blog} />
//           <BlogArticle blog={blog} />
//         </Fragment>
//       )}
//       {!blog && <NotFound />}
//     </Fragment>
//   );
// }
//
// export default BlogEntry;
